import { baseApi, resourceScopeTag, resourceTag } from '@krp/client-runtime'

import type { AqsiProfile } from '../model/types'
import { decodeAqsiProfile } from './contracts'
import { AQSI_CONNECTION_URLS } from './urls'

/** Тег диагностики кабинета: `<rid>:PROFILE`; сброс области rid перечитывает его. */
export const AQSI_DIAGNOSTICS_TAG = 'AqsiDiagnostics' as const

export interface AqsiResourceArgs {
  resourceId: string
}

export const aqsiConnectionApi = baseApi.enhanceEndpoints({ addTagTypes: [AQSI_DIAGNOSTICS_TAG] }).injectEndpoints({
  endpoints: (build) => ({
    aqsiProfile: build.query<AqsiProfile, AqsiResourceArgs>({
      query: ({ resourceId }) => ({ url: AQSI_CONNECTION_URLS.profile(resourceId), decode: decodeAqsiProfile }),
      providesTags: (_result, _error, { resourceId }) => [
        resourceTag(AQSI_DIAGNOSTICS_TAG, resourceId, 'PROFILE'),
        resourceScopeTag(resourceId),
      ],
    }),
  }),
})

export const { aqsiProfile } = aqsiConnectionApi.endpoints
